import type { ComponentType } from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import type { ExportImageProps } from '@atlassian/jira-software-roadmap-image-export';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazySharingExport = lazyAfterPaint<ComponentType<ExportImageProps>>(
	() => import(/* webpackChunkName: "async-business-timeline-sharing-export" */ './main'),
	{ ssr: false },
);
